import { lazy } from 'react';
import InputSkeleton from '../../../skeleton_loaders/common/InputSkeleton.jsx';
import withSuspense from '../../../helpers/withSuspense';

const DashboardImageUploadButton = withSuspense(lazy(() => import('./DashboardImageUploadButton.jsx')), InputSkeleton)

export default DashboardImageUploadButton;
